<script>import { createEventDispatcher } from "svelte";
export let value = 0;
export let max = 5;
export let interactive = false;
export let text = "text-token";
export let fill = "fill-token";
export let justify = "justify-center";
export let spacing = "space-x-2";
export let regionIcon = "";
const dispatch = createEventDispatcher();
function iconClick(index) {
  dispatch("icon", {
    index: index + 1
  });
}
const cBase = "w-full flex";
$:
  elemInteractive = interactive ? "button" : "span";
$:
  attrInteractive = interactive ? { type: "button" } : {};
$:
  classesBase = `${cBase} ${text} ${fill} ${justify} ${spacing} ${$$props.class ?? ""}`;
</script>

<div class="ratings {classesBase}" data-testid="rating-bar">
	<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
	{#each Array(max) as _, i}
		{#if Math.floor(value) >= i + 1}
			<svelte:element this={elemInteractive} {...attrInteractive} class="rating-icon {regionIcon}" on:click={() => iconClick(i)}>
				<slot name="full" />
			</svelte:element>
		{:else if value === i + 0.5}
			<svelte:element this={elemInteractive} {...attrInteractive} class="rating-icon {regionIcon}" on:click={() => iconClick(i)}>
				<slot name="half" />
			</svelte:element>
		{:else}
			<svelte:element this={elemInteractive} {...attrInteractive} class="rating-icon {regionIcon}" on:click={() => iconClick(i)}>
				<slot name="empty" />
			</svelte:element>
		{/if}
	{/each}
</div>
